var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDashedLine = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 1250 2"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "url(#paint0_linear_2558_85842)",
  strokeDasharray: "2.42 2.42",
  d: "M0 1h1250"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_2558_85842",
  x1: 0,
  x2: 1250,
  y1: 1.5,
  y2: 1.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#98B2BF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.171,
  stopColor: "#98B2BF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.831,
  stopColor: "#98B2BF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#98B2BF",
  stopOpacity: 0
})))));
export { SvgDashedLine as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMjUwIDIiIGZpbGw9Im5vbmUiPgogICAgPHBhdGggZD0iTTAgMUwxMjUwIDEuMDAwMTEiIHN0cm9rZT0idXJsKCNwYWludDBfbGluZWFyXzI1NThfODU4NDIpIiBzdHJva2UtZGFzaGFycmF5PSIyLjQyIDIuNDIiIC8+CiAgICA8ZGVmcz4KICAgICAgICA8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfMjU1OF84NTg0MiIgeDE9Ii00LjM3MTE0ZS0wOCIgeTE9IjEuNSIgeDI9IjEyNTAiCiAgICAgICAgICAgIHkyPSIxLjUwMDExIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CiAgICAgICAgICAgIDxzdG9wIHN0b3AtY29sb3I9IiM5OEIyQkYiIHN0b3Atb3BhY2l0eT0iMCIgLz4KICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwLjE3MTM1OCIgc3RvcC1jb2xvcj0iIzk4QjJCRiIgLz4KICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIwLjgzMDYwOSIgc3RvcC1jb2xvcj0iIzk4QjJCRiIgLz4KICAgICAgICAgICAgPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjOThCMkJGIiBzdG9wLW9wYWNpdHk9IjAiIC8+CiAgICAgICAgPC9saW5lYXJHcmFkaWVudD4KICAgIDwvZGVmcz4KPC9zdmc+";